import { Suspense, lazy, memo, useCallback, useState } from 'react';

import { IconButton, PrimaryButton } from '@pulse-web-ui/button-v2';
import { Modal } from '@pulse-web-ui/modal';
import { useTheme } from '@pulse-web-ui/theme';

import {
  HeaderWrapper,
  HintButton,
  StyledContent,
  StyledDescription,
  StyledTitle,
} from './button-with-modal.styles';

const Close = lazy(() => import('@pulse-web-ui/icons/lib/lazy/close'));

interface Props {
  label: string;
  title?: string;
  description?: string;
  submitLabel?: string;
}

export const ButtonWithModal = memo(
  ({ label, title, description, submitLabel }: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const theme = useTheme();
    const handleCloseModal = useCallback(() => setIsOpen(false), []);
    const handleOpenModal = useCallback(() => setIsOpen(true), []);

    return (
      <>
        <HintButton
          size='m'
          onClick={handleOpenModal}
        >
          {label}
        </HintButton>
        <Modal
          closeIcon={false}
          showDialog={isOpen}
          closeHandler={handleCloseModal}
        >
          <StyledContent>
            <HeaderWrapper>
              {title && <StyledTitle>{title}</StyledTitle>}
              <IconButton
                size='s'
                variant='secondary'
                onClick={handleCloseModal}
                icon={
                  <Suspense fallback={null}>
                    <Close
                      width={20}
                      color={theme.colors.icon.primary}
                    />
                  </Suspense>
                }
              />
            </HeaderWrapper>
            {description && (
              <StyledDescription>{description}</StyledDescription>
            )}
            <PrimaryButton
              size='l'
              onClick={handleCloseModal}
            >
              {submitLabel}
            </PrimaryButton>
          </StyledContent>
        </Modal>
      </>
    );
  }
);
